import React from "react";
import "./Footer.scss";

const Footer = () => {
  return (
    <div className="footer-section">
      <div className="footer-link-and-copyright-sec">
        <div className="footer-copyright">
          <span> ©&nbsp;2024 IPAS </span>
        </div>
        <div className="footer-list">
          <ul className="footer-link-and-icon">
            <li className="lg:list-none md:list-none list-disc text-[#838383]">
              <a href="#" rel="noopener noreferrer">
                Terms &amp; Conditions of Use of Website
              </a>
            </li>
            <li className="list-disc ">
              <a href="#" rel="noopener noreferrer">
                Privacy Policy
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;
